import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ServiceNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-28">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-48 h-24 flex items-center justify-center">
              <img 
                src={isScrolled 
                  ? "https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/f80f0ad8019cef13d6a90e36f07c49f1.png"
                  : "https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/ac092ddd5e8296cd231c029d8c3ac0cf.png"
                }
                alt="unuu Logo" 
                className="w-full h-full object-contain"
              />
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-[#00989e] whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Services
            </Link>
            <Link
              to="/case-studies"
              className={`text-sm font-medium transition-colors hover:text-[#00989e] whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Case Studies
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-[#00989e] whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              About
            </Link>
            <Link
              to="/blog"
              className={`text-sm font-medium transition-colors hover:text-[#00989e] whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/assessment"
              className={`text-sm font-medium transition-colors hover:text-[#00989e] whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Assessment
            </Link>
            <button className="px-6 py-2.5 bg-[#00989e] text-white text-sm font-semibold rounded-full hover:bg-[#007a7f] transition-colors whitespace-nowrap cursor-pointer">
              Let's Talk
            </button>
          </div>

          <button className="md:hidden cursor-pointer">
            <i className={`ri-menu-line text-2xl ${
              isScrolled ? 'text-slate-900' : 'text-white'
            }`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
